<template>
  <section>
    <b-row
      v-if="loading"
      class="mx-n50"
    >
      <b-col
        v-for="i in 10"
        :key="i"
        class="px-50 mb-1"
        sm="6"
        md="4"
        lg="3"
      >
        <b-card>
          <b-skeleton-img />
          <b-skeleton
            animation="wave"
            width="75%"
            class="my-2"
          />
          <b-skeleton
            animation="wave"
            width="25%"
          />
          <b-skeleton
            animation="wave"
            width="45%"
          />
          <b-skeleton
            animation="wave"
            width="65%"
          />
        </b-card>
      </b-col>
    </b-row>
    <b-row
      v-else
      class="mx-n50"
    >
      <b-col
        v-for="video in videos"
        :key="video.id"
        class="px-50 mb-1"
        sm="6"
        md="4"
        lg="3"
      >
        <GalleryVideosItem :video="video" />
      </b-col>
    </b-row>
    <InfiniteLoading
      :key="$route.params.accountId"
      spinner="spiral"
      @infinite="getNextVideos($event)"
    >
      <div slot="no-results" />
      <div slot="no-more" />
    </InfiniteLoading>
  </section>
</template>

<script>
import notification from '@/mixins/toastification'
import GalleryService from '@/api/client/gallery.service'
import InfiniteLoading from 'vue-infinite-loading'
import GalleryVideosItem from './GalleryVideosItem.vue'

export default {
  components: {
    GalleryVideosItem,
    InfiniteLoading,
  },
  mixins: [notification],
  data() {
    return {
      videos: {},
      page: 0,
      loading: false,
    }
  },
  watch: {
    '$route.params.accountId': 'reloadGalleryVideos',
  },
  async mounted() {
    this.reloadGalleryVideos()
  },
  methods: {
    async reloadGalleryVideos() {
      this.loading = true
      this.page = 0
      try {
        this.videos = await GalleryService.getVideos(this.page, this.$route.params.accountId)
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loading = false
      }
    },
    async getNextVideos($state) {
      try {
        // eslint-disable-next-line no-plusplus
        const videos = await GalleryService.getVideos(++this.page, this.$route.params.accountId)
        if (videos.length) {
          this.videos.push(...videos)
          if ($state) $state.loaded()
        } else if ($state) $state.complete()
      } catch (error) {
        this.error(error.message)
      }
    },
  },
}
</script>
